import Vue from "vue";
import Avatar from "../components/Avatar.vue";
let AvatarComponent = Vue.extend(Avatar);
const renderAvatar = ({ url, username, size = "sm" }) => {
  let instance = new AvatarComponent({
    propsData: {
      url: url,
      username: username,
      size: "sm",
      lazy: false
    }
  });
  instance.$mount();
  let $el = instance.$el;
  return $el.outerHTML;
};

export default renderAvatar;
